// src/store/mappers/organization/profile.mapper.ts
import type { OrgProfileDTO, SeatSummaryDTO } from '@/types/organization.dtos';
import type { OrganizationProfile } from '@/types/organization.types';
import { formatDate } from '@/utils/format';
import { mapSeatSummaryDTOToSeats } from '@/store/mappers/organization/seats.mapper';

/**
 * Map OrgProfileDTO → OrganizationProfile
 * Also returns seats mapping helper (since seats now arrive inside profile).
 */
export function mapOrgProfileDTOToProfile(dto: OrgProfileDTO): {
  profile: OrganizationProfile;
  seats?: { internalSeats: { available: number; active: number; new: number; inactive: number };
            externalSeats: { available: number; active: number; new: number; inactive: number } } | undefined;
} {
  const profile: OrganizationProfile = {
    name: dto.name,
    customerSince: formatDate(dto.createdAt),
    phone: dto.phone,
    address: {
      line1: dto.address.line1,
      line2: dto.address.line2,
      city: dto.address.city,
      state: dto.address.state,
      zip: dto.address.postalCode,
    },
    appDomain: dto.appDomain,
  };

  let seats: ReturnType<typeof mapSeatSummaryDTOToSeats> | undefined = undefined;
  if (dto.seats !== undefined) {
    // mapSeatSummaryDTOToSeats expects internalSeats/externalSeats shaped DTO;
    // adapt backend shape { internal, external } -> SeatSummaryDTO expected by mapper
    const seatDto: SeatSummaryDTO = {
      internal: dto.seats.internal,
      external: dto.seats.external,
    };
    seats = mapSeatSummaryDTOToSeats(seatDto);
  }

  return { profile, seats };
}
